module.exports = __webpack_public_path__ + "img/heartsArrows-2.00988b1.webp";